import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=4e2453c0"
import script from "./RegisterPage.js?vue&type=script&lang=js&external"
export * from "./RegisterPage.js?vue&type=script&lang=js&external"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=4e2453c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports